goog.provide("shadow.js.shim.module$react_bootstrap$DropdownButton$default");
shadow.js.shim.module$react_bootstrap$DropdownButton$default = shadow.js.require(142, {}).default;
